/* Andix · AI shopping assistant (snippets/aa-chat.liquid).
   Streams replies from the chat worker, keeps the conversation for 24 h across pages, turns product
   links into live mini cards, offers human contact when the reply asks for it, announces once per visit
   that Andix is online (an "island" that grows out of the header avatar) and opens with a circular reveal
   from the trigger (bottom sheet with swipe-to-close on phones). */
(() => {
  if (window.__aaChat) return;
  const root = document.querySelector('[data-aa-chat]');
  const trigger = document.querySelector('[data-aa-chat-open]');
  if (!root || !trigger) return;
  window.__aaChat = true;

  const STORE_KEY = 'aa-andix-v1';
  const OPEN_KEY = 'aa-andix-open';
  const INTRO_KEY = 'aa-andix-intro';
  const TTL = 24 * 60 * 60 * 1000;
  const mqMobile = window.matchMedia('(max-width: 749px)');
  const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reduced = () => mqReduced.matches;
  // Phones: Andix takes the search button's place, left of the logo, so the logo gets more room (owner's choice,
  // 28/10/2026). Wider screens: back in header-actions.
  const homeMark = document.createComment('aa-andix');
  trigger.before(homeMark);
  const placeTrigger = () => {
    const slot = mqMobile.matches && document.querySelector('.aa-search-btn--m');
    if (slot) slot.before(trigger); else homeMark.after(trigger);
    trigger.classList.toggle('aa-andix--left', !!slot);
  };
  placeTrigger();
  mqMobile.addEventListener('change', placeTrigger);
  // Andix at the top of the phone menu drawer (snippets/aa-drawer-top.liquid) opens the chat from the header avatar
  document.addEventListener('click', (e) => {
    if (e.target instanceof Element && e.target.closest('[data-aa-chat-alt]')) setTimeout(() => trigger.click(), 60);
  });
  // Island room on phones when Andix is on the left: up to the cart (last 60 px of the bar)
  const phoneRoom = (r) => window.innerWidth - 60 - r.left;

  const $ = (sel) => root.querySelector(sel);
  const log = $('[data-aa-chat-log]');
  const body = $('[data-aa-chat-body]');
  const hero = $('[data-aa-chat-hero]');
  const head = $('[data-aa-chat-head]');
  const form = $('[data-aa-chat-form]');
  const input = $('[data-aa-chat-input]');
  const sendBtn = $('[data-aa-chat-send]');
  const status = $('[data-aa-chat-status]');
  const statusIdle = status.textContent;
  const name = root.dataset.name || 'Andix';
  const avatarSrc = trigger.dataset.avatar || trigger.querySelector('img')?.getAttribute('src') || '';
  const endpoint = (() => {
    try { const o = localStorage.getItem('aaChatEndpoint'); if (o) return o; } catch (e) { /* storage blocked */ }
    return root.dataset.endpoint || '';
  })();

  let ctxBase = {};
  try { ctxBase = JSON.parse(document.querySelector('[data-aa-chat-ctx]')?.textContent || '{}'); } catch (e) { ctxBase = {}; }

  // The header can be transformed (sticky/hide on scroll); fixed layers must live under <body>.
  document.body.appendChild(root);
  const scrim = document.createElement('div');
  scrim.className = 'aa-chat-scrim';
  scrim.hidden = true;
  document.body.appendChild(scrim);

  // ---------- State ----------
  let state = load();
  markChatting();
  let busy = false;
  let lastFocus = null;
  let closing = null;

  function load() {
    try {
      const s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (s && Array.isArray(s.msgs) && Date.now() - (s.at || 0) < TTL) return s;
    } catch (e) { /* ignore */ }
    return { at: Date.now(), msgs: [] };
  }
  function save() {
    state.at = Date.now();
    state.msgs = state.msgs.slice(-40);
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
    markChatting();
  }
  // Header chat icon turns green while there is a conversation (aa-header.css › .aa-andix.is-chatting)
  function markChatting() { trigger.classList.toggle('is-chatting', state.msgs.some((m) => m.r === 'u')); }

  // ---------- Rendering ----------
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function safeHref(href) {
    try {
      const u = new URL(href, location.origin);
      const ownHost = u.origin === location.origin || /(^|\.)theandesaustrix\.com$/.test(u.hostname);
      // "//host" would be read as another site: keep a single leading slash
      return ownHost ? u.pathname.replace(/^\/+/, '/') + u.search + u.hash : null;
    } catch (e) { return null; }
  }
  function inline(s) {
    let out = esc(s);
    out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (m, text, href) => {
      const h = safeHref(href.replace(/&amp;/g, '&'));
      return h ? `<a href="${esc(h)}" data-aa-chat-link>${text}</a>` : text;
    });
    return out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }
  function md(text) {
    const blocks = [];
    let list = null;
    for (const raw of String(text).split('\n')) {
      const line = raw.trim();
      const li = line.match(/^[-*•]\s+(.*)/);
      if (li) { (list ||= []).push(`<li>${inline(li[1])}</li>`); continue; }
      if (list) { blocks.push(`<ul>${list.join('')}</ul>`); list = null; }
      if (line) blocks.push(`<p>${inline(line)}</p>`);
    }
    if (list) blocks.push(`<ul>${list.join('')}</ul>`);
    return blocks.join('');
  }
  const CARET = '<span class="aa-chat__caret" aria-hidden="true"></span>';
  function withCaret(html) {
    const i = Math.max(html.lastIndexOf('</p>'), html.lastIndexOf('</li>'));
    return i < 0 ? html + CARET : html.slice(0, i) + CARET + html.slice(i);
  }
  const timeOf = (ts) => new Date(ts).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
  const HANDOFF = /\s*\[\[\s*HUMANO\s*\]\]\s*/gi;
  const hasHandoff = (t) => /\[\[\s*HUMANO\s*\]\]/i.test(t);

  function bubble(role, opts = {}) {
    const li = document.createElement('li');
    li.className = `aa-chat__msg aa-chat__msg--${role}`;
    const prev = log.lastElementChild;
    if (prev && prev.classList.contains(`aa-chat__msg--${role}`)) li.classList.add('aa-chat__msg--cont');
    if (role === 'm') li.innerHTML = `<img class="aa-chat__msg-av" src="${esc(avatarSrc)}" alt="" width="26" height="26">`;
    const b = document.createElement('div');
    b.className = 'aa-chat__bubble' + (opts.error ? ' is-error' : '');
    li.appendChild(b);
    log.appendChild(li);
    return b;
  }
  function fill(b, role, text, ts, final) {
    const clean = text.replace(HANDOFF, ' ').trim();
    let html = role === 'u' ? `<p>${esc(clean).replace(/\n/g, '<br>')}</p>` : md(clean);
    html = final ? html + `<span class="aa-chat__time">${timeOf(ts)}</span>` : withCaret(html);
    b.innerHTML = html;
  }
  function renderMessage(m, animate) {
    const b = bubble(m.r, { error: m.err });
    if (!animate) b.parentElement.style.animation = 'none';
    fill(b, m.r, m.t, m.ts, true);
    if (m.r === 'm') enhance(b, m.t);
    return b;
  }
  function scrollDown(force) {
    const near = body.scrollHeight - body.scrollTop - body.clientHeight < 160;
    if (force || near) body.scrollTo({ top: body.scrollHeight, behavior: force || reduced() ? 'auto' : 'smooth' });
  }

  // Product links become live mini cards (price and stock read from the storefront).
  const productCache = new Map();
  function productData(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null));
    }
    return productCache.get(handle);
  }
  const money = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL');
  const ARROW = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  function enhance(b, text) {
    const timeEl = b.querySelector('.aa-chat__time');
    const handles = [...new Set([...b.querySelectorAll('a[data-aa-chat-link]')].map((a) => (a.getAttribute('href').match(/^\/products\/([^/?#]+)/) || [])[1]).filter(Boolean))].slice(0, 3);
    if (handles.length) {
      const wrap = document.createElement('div');
      wrap.className = 'aa-chat__cards';
      b.insertBefore(wrap, timeEl);
      handles.forEach(async (h) => {
        const p = await productData(h);
        if (!p) return;
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=120` : '';
        const cmp = p.compare_at_price > p.price ? `<s>${money(p.compare_at_price)}</s>` : '';
        const a = document.createElement('a');
        a.className = 'aa-chat__card' + (p.available ? '' : ' is-soldout');
        a.href = `/products/${p.handle}`;
        a.setAttribute('data-aa-chat-link', '');
        a.innerHTML = `${img ? `<img src="${esc(img)}" alt="" width="50" height="50" loading="lazy">` : ''}<span class="aa-chat__card-txt"><strong>${esc(p.title)}</strong><span>${money(p.price)}${cmp}</span><em>${p.available ? 'Disponible' : 'Agotado · avísame cuando vuelva'}</em></span><span class="aa-chat__card-go">${ARROW}</span>`;
        wrap.appendChild(a);
        scrollDown();
      });
    }
    if (hasHandoff(text)) {
      // Customers reach the team only through the contact form (no public email address)
      const box = document.createElement('div');
      box.className = 'aa-chat__handoff';
      box.innerHTML = `<p>¿Prefieres que te atienda alguien del equipo?</p><div><a href="${esc(root.dataset.contact)}" data-aa-chat-link>Ir al formulario de contacto</a></div>`;
      b.insertBefore(box, timeEl);
    }
  }

  function typingRow() {
    const li = document.createElement('li');
    li.className = 'aa-chat__msg aa-chat__msg--m';
    li.innerHTML = `<img class="aa-chat__msg-av" src="${esc(avatarSrc)}" alt="" width="26" height="26"><div class="aa-chat__bubble aa-chat__typing" aria-label="${esc(name)} está escribiendo"><i></i><i></i><i></i></div>`;
    log.appendChild(li);
    setStatus(`${name} está escribiendo…`, true);
    scrollDown(true);
    return li;
  }
  function setStatus(text, typing) {
    status.textContent = text;
    status.parentElement.classList.toggle('is-typing', !!typing);
  }
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  // ---------- Hero ----------
  function syncHero() {
    hero.hidden = state.msgs.length > 0;
  }
  async function leaveHero() {
    if (hero.hidden) return;
    hero.classList.add('is-leaving');
    await wait(reduced() ? 0 : 240);
    hero.hidden = true;
    hero.classList.remove('is-leaving');
  }
  root.querySelectorAll('[data-aa-chat-starter]').forEach((btn) => {
    btn.addEventListener('click', () => send(btn.dataset.aaChatStarter));
  });

  // ---------- Context ----------
  async function pageContext() {
    const ctx = { path: location.pathname, title: document.title.replace(/\s*[|–-]\s*The Andes Austrix.*$/i, ''), template: ctxBase.template };
    if (ctxBase.product) {
      const p = ctxBase.product;
      const id = Number(new URLSearchParams(location.search).get('variant')) || p.variant;
      const v = p.variants.find((x) => x.id === id) || p.variants[0] || {};
      ctx.product = { title: p.title, url: p.url, price: v.price, compare: v.compare, available: !!v.available, variant: p.variants.length > 1 ? v.title : '' };
    }
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      ctx.cart = { count: cart.item_count, total: money(cart.total_price), items: cart.items.slice(0, 10).map((i) => ({ title: i.product_title + (i.variant_title ? ` (${i.variant_title})` : ''), qty: i.quantity })) };
    } catch (e) { /* cart unavailable */ }
    // Comuna elegida en "Enviar a" (snippets/aa-shipto.liquid): Andix responde plazos sin volver a preguntarla
    const ship = window.AAShipto?.get?.(), zone = ship?.c && window.AAShipto.zone(ship.r);
    if (zone) {
      const eta = document.querySelector('[data-aa-eta-text]')?.textContent.replace(/\s+/g, ' ').trim();
      ctx.ship = { comuna: ship.c, region: zone.n, ok: window.AAShipto.covered(zone, ship.c), days: `${zone.min} a ${zone.max}`, eta: /^Recíbelo/.test(eta || '') ? eta : '' };
    }
    return ctx;
  }

  // ---------- Conversation ----------
  async function send(text) {
    text = String(text || '').trim();
    if (!text || busy) return;
    busy = true;
    sendBtn.disabled = true;
    sendBtn.classList.remove('is-sent');
    void sendBtn.offsetWidth;
    sendBtn.classList.add('is-sent');
    await leaveHero();
    const um = { r: 'u', t: text, ts: Date.now() };
    state.msgs.push(um);
    save();
    renderMessage(um, true);
    scrollDown(true);

    const started = Date.now();
    const row = typingRow();
    try {
      if (!endpoint) throw Object.assign(new Error('no-endpoint'), { friendly: `${name} se está preparando y muy pronto estará disponible. Mientras, escríbenos desde el formulario de contacto.` });
      const ctx = await pageContext();
      const messages = state.msgs.filter((m) => !m.err).slice(-16).map((m) => ({ role: m.r === 'u' ? 'user' : 'model', text: m.t }));
      const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages, ctx }) });
      if (!res.ok) {
        let msg = '';
        try { msg = (await res.json()).message || ''; } catch (e) { /* not JSON */ }
        throw Object.assign(new Error('http ' + res.status), { friendly: msg });
      }
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let shown = '';
      let pending = '';
      let doneStreaming = false;
      const pump = (async () => {
        for (;;) {
          const { value, done } = await reader.read();
          if (done) break;
          pending += dec.decode(value, { stream: true });
        }
        pending += dec.decode();
        doneStreaming = true;
      })();
      // A short, natural pause before the first words (reading and thinking time).
      const minDelay = reduced() ? 0 : Math.min(1300, 500 + text.length * 7);
      while (!pending && !doneStreaming) await wait(40);
      const elapsed = Date.now() - started;
      if (elapsed < minDelay) await wait(minDelay - elapsed);
      row.remove();
      const b = bubble('m');
      while (!doneStreaming || pending) {
        if (pending) {
          let n = reduced() ? pending.length : Math.max(2, Math.ceil(pending.length / 14));
          // Never split an emoji (UTF-16 surrogate pair) between two frames
          if (n < pending.length && /[\uD800-\uDBFF]/.test(pending[n - 1])) n += 1;
          shown += pending.slice(0, n);
          pending = pending.slice(n);
          fill(b, 'm', shown, 0, false);
          scrollDown();
        }
        await wait(reduced() ? 0 : 22);
      }
      await pump;
      const reply = shown.trim();
      const mm = { r: 'm', t: reply, ts: Date.now() };
      state.msgs.push(mm);
      save();
      fill(b, 'm', reply, mm.ts, true);
      enhance(b, reply);
    } catch (e) {
      row.remove();
      const error = e.friendly || (navigator.onLine === false ? 'Parece que se cortó tu conexión. Revisa tu internet y vuelve a intentarlo.' : `Uy, no me llegó bien tu mensaje. ¿Lo intentas de nuevo? Si es urgente, escríbenos desde el formulario de contacto.`);
      renderMessage({ r: 'm', t: error, ts: Date.now(), err: true }, true);
    }
    setStatus(statusIdle, false);
    busy = false;
    sendBtn.disabled = false;
    scrollDown(true);
    if (!mqMobile.matches) input.focus({ preventScroll: true });
  }

  // ---------- Open / close ----------
  function place() {
    if (mqMobile.matches) return;
    const r = trigger.getBoundingClientRect();
    const header = trigger.closest('header, .header, #header-component') || trigger;
    const hb = header.getBoundingClientRect().bottom;
    root.style.setProperty('--aa-chat-top', `${Math.max(12, Math.round((hb > 0 ? hb : r.bottom) + 10))}px`);
  }
  function setOrigin() {
    const r = trigger.getBoundingClientRect();
    const p = root.getBoundingClientRect();
    root.style.setProperty('--ox', `${Math.round(r.left + r.width / 2 - p.left)}px`);
    root.style.setProperty('--oy', `${Math.round(r.top + r.height / 2 - p.top)}px`);
  }
  function open(focus = true) {
    hideIsland(true);
    if (closing) { clearTimeout(closing); closing = null; root.classList.remove('is-out'); }
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    place();
    root.hidden = false;
    setOrigin();
    root.classList.remove('is-in');
    void root.offsetWidth;
    root.classList.add('is-in');
    trigger.setAttribute('aria-expanded', 'true');
    if (mqMobile.matches) {
      document.documentElement.classList.add('aa-chat-lock');
      scrim.hidden = false;
      scrim.classList.remove('is-out');
    }
    try { sessionStorage.setItem(OPEN_KEY, '1'); sessionStorage.setItem(INTRO_KEY, '1'); } catch (e) { /* ignore */ }
    if (!log.children.length) state.msgs.forEach((m) => renderMessage(m, false));
    syncHero();
    scrollDown(true);
    if (focus && !mqMobile.matches) setTimeout(() => input.focus({ preventScroll: true }), reduced() ? 0 : 280);
  }
  function close() {
    if (root.hidden || closing) return;
    trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('aa-chat-lock');
    try { sessionStorage.removeItem(OPEN_KEY); } catch (e) { /* ignore */ }
    if (!scrim.hidden) scrim.classList.add('is-out');
    setOrigin();
    root.classList.remove('is-in');
    root.classList.add('is-out');
    closing = setTimeout(() => {
      closing = null;
      root.hidden = true;
      root.classList.remove('is-out', 'is-dragging');
      root.style.removeProperty('transform');
      root.style.removeProperty('--drag');
      scrim.hidden = true;
      trigger.classList.remove('is-pulse');
      void trigger.offsetWidth;
      trigger.classList.add('is-pulse');
    }, reduced() ? 0 : 330);
    (lastFocus && document.contains(lastFocus) ? lastFocus : trigger).focus({ preventScroll: true });
  }
  function reset() {
    // A reply still streaming would write into the cleared conversation
    if (busy) return;
    state = { at: Date.now(), msgs: [] };
    save();
    log.innerHTML = '';
    hero.hidden = false;
    hero.querySelectorAll('.aa-chat__starter').forEach((s) => { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = ''; });
    body.scrollTop = 0;
    input.focus({ preventScroll: true });
  }

  trigger.setAttribute('aria-expanded', 'false');
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    root.hidden || closing ? open() : close();
  });
  // Buttons elsewhere on the page (contact page card) open the chat and, if they carry one, ask their question
  document.addEventListener('click', (e) => {
    const ask = e.target.closest('[data-aa-chat-ask]');
    if (!ask || root.contains(ask)) return;
    e.preventDefault();
    const q = ask.dataset.aaChatAsk;
    open(!q);
    if (q) send(q);
  });
  $('[data-aa-chat-close]').addEventListener('click', close);
  $('[data-aa-chat-reset]').addEventListener('click', reset);
  scrim.addEventListener('click', close);
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.stopPropagation(); close(); }
  });
  // Esc also closes it when focus is elsewhere on the page (desktop panel is not modal)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden && !e.defaultPrevented && !document.querySelector('dialog[open]')) close();
  });
  document.addEventListener('pointerdown', (e) => {
    if (root.hidden || mqMobile.matches) return;
    if (!root.contains(e.target) && !trigger.contains(e.target) && !e.target.closest('[data-aa-chat-ask]')) close();
  }, true);
  window.addEventListener('resize', () => { if (!root.hidden) place(); });
  // The sticky header shrinks once the announcement bar scrolls away: keep the panel right under it
  let placeFrame = 0;
  window.addEventListener('scroll', (e) => {
    if (root.hidden || placeFrame || root.contains(e.target)) return;
    placeFrame = requestAnimationFrame(() => { placeFrame = 0; place(); });
  }, { passive: true, capture: true });
  // Phone ↔ desktop while open (rotation, resized window): scrim and scroll lock only belong to the sheet
  mqMobile.addEventListener('change', () => {
    if (root.hidden) return;
    scrim.hidden = !mqMobile.matches;
    document.documentElement.classList.toggle('aa-chat-lock', mqMobile.matches);
    place();
  });
  // Links inside the chat navigate; on desktop the chat reopens on the next page so the talk continues.
  root.addEventListener('click', (e) => {
    if (e.target.closest('a[href]') && mqMobile.matches) { try { sessionStorage.removeItem(OPEN_KEY); } catch (err) { /* ignore */ } }
  });

  // Swipe down on the sheet header to close (phones)
  let drag = null;
  const grabZone = [head, $('[data-aa-chat-grab]')];
  grabZone.forEach((el) => el && el.addEventListener('pointerdown', (e) => {
    if (!mqMobile.matches || e.target.closest('button')) return;
    drag = { y: e.clientY, dy: 0, id: e.pointerId };
    root.classList.add('is-dragging');
    el.setPointerCapture?.(e.pointerId);
  }));
  window.addEventListener('pointermove', (e) => {
    if (!drag || e.pointerId !== drag.id) return;
    drag.dy = Math.max(0, e.clientY - drag.y);
    root.style.transform = `translateY(${drag.dy}px)`;
    root.style.setProperty('--drag', `${drag.dy}px`);
  });
  const endDrag = (e) => {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    const dy = drag.dy;
    drag = null;
    root.classList.remove('is-dragging');
    if (dy > 110) close();
    else { root.style.removeProperty('transform'); root.style.removeProperty('--drag'); }
  };
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  // ---------- Composer ----------
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const text = input.value;
    input.value = '';
    autosize();
    send(text);
  });
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit(); }
  });
  function autosize() {
    // Measure from 0: the theme gives textareas a minimum height, so "auto" would not shrink back
    input.style.height = '0px';
    input.style.height = Math.max(38, Math.min(120, input.scrollHeight)) + 'px';
    form.classList.toggle('has-text', !!input.value.trim());
  }
  input.addEventListener('input', autosize);

  // ---------- "Online" island (once per visit) ----------
  // Built inside the trigger, so it travels with the sticky header (no floating duplicate when scrolling)
  // and stays open in the bar while the visitor scrolls.
  let island = null;
  let islandTimer = null;
  let islandWidth = 0;
  const ISLAND_HOLD = 7000;
  function triggerVisible() {
    const r = trigger.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  // Desktop: the island covers exactly the search pill next to the trigger (never the nav or the Promo tag).
  // Phones (search is just an icon): grow left but keep the menu and search icons free.
  function searchPill() {
    const r = trigger.getBoundingClientRect();
    const mid = r.top + r.height / 2;
    return [...document.querySelectorAll('.aa-search-btn')].find((el) => {
      const b = el.getBoundingClientRect();
      return b.width > 80 && b.right <= r.left + 1 && Math.abs(b.top + b.height / 2 - mid) < 24;
    });
  }
  function fitIsland() {
    if (!island) return;
    const r = trigger.getBoundingClientRect();
    const pill = searchPill();
    const w = pill
      ? r.right - pill.getBoundingClientRect().left
      : trigger.classList.contains('aa-andix--left') ? Math.min(islandWidth, phoneRoom(r), 380)
      : Math.min(islandWidth, Math.max(r.width, r.right - (mqMobile.matches ? 116 : 12)), 380);
    island.style.setProperty('--w', `${Math.round(w)}px`);
  }
  function scheduleCollapse(ms) {
    clearTimeout(islandTimer);
    islandTimer = setTimeout(() => {
      // While the header is off screen or the tab is in the background, keep it open for later
      if (!triggerVisible() || document.hidden) { scheduleCollapse(1500); return; }
      hideIsland();
    }, ms);
  }
  function hideIsland(now) {
    if (!island) return;
    const el = island;
    island = null;
    clearTimeout(islandTimer);
    const finish = () => { el.remove(); if (!island) trigger.classList.remove('has-island'); };
    if (now || reduced()) { finish(); return; }
    el.classList.remove('is-open');
    setTimeout(() => {
      el.classList.add('is-gone');
      trigger.classList.remove('is-pulse');
      void trigger.offsetWidth;
      trigger.classList.add('is-pulse');
      setTimeout(finish, 360);
    }, 620);
  }
  function showIsland(attempt = 0) {
    if (root.dataset.nudge !== 'true' || !root.hidden || island) return;
    if (!triggerVisible()) {
      if (attempt < 10) setTimeout(() => showIsland(attempt + 1), 1500);
      return;
    }
    try { if (sessionStorage.getItem(INTRO_KEY)) return; sessionStorage.setItem(INTRO_KEY, '1'); } catch (e) { return; }
    // Longest sentence first; the one that fits the room in full is used
    const options = ctxBase.product
      ? ['¿Dudas con este producto? Pregúntame', '¿Dudas con este producto?', '¿Dudas? Pregúntame']
      : ['Hola, ¿te ayudo a encontrar algo?', '¿Buscas algo? Te ayudo', 'Hola, ¿te ayudo?'];
    const el = document.createElement('span');
    el.className = 'aa-andix-island';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = `<span class="aa-andix__ring"><img src="${esc(avatarSrc)}" alt="" width="36" height="36"></span><span class="aa-andix-island__txt"><small>${esc(name)} · en línea</small><span></span></span>`;
    trigger.appendChild(el);
    trigger.classList.add('has-island');
    island = el;
    const typed = el.querySelector('.aa-andix-island__txt span');
    // Room: the search pill on desktop, the free header space on phones; text room = room − avatar − paddings
    const probe = document.createElement('span');
    const cs = getComputedStyle(typed);
    probe.style.cssText = `position:absolute;visibility:hidden;white-space:nowrap;font-size:${cs.fontSize};font-weight:${cs.fontWeight};font-family:${cs.fontFamily}`;
    el.appendChild(probe);
    const measure = (s) => { probe.textContent = s; return probe.offsetWidth; };
    const r = trigger.getBoundingClientRect();
    const pill = searchPill();
    const room = pill ? r.right - pill.getBoundingClientRect().left
      : trigger.classList.contains('aa-andix--left') ? Math.min(380, phoneRoom(r))
      : Math.min(380, Math.max(r.width, r.right - (mqMobile.matches ? 116 : 12)));
    const avatarBox = trigger.offsetHeight;
    const textRoom = room - avatarBox - 30;
    const message = options.find((s) => measure(s) <= textRoom) || options[options.length - 1];
    islandWidth = avatarBox + Math.max(measure(message), 110) + 34;
    probe.remove();
    fitIsland();
    // Esc or a click/tap anywhere else dismisses it (a click on it opens the chat through the trigger)
    const dismiss = new AbortController();
    const stop = () => dismiss.abort();
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { stop(); if (island === el) hideIsland(); } }, { signal: dismiss.signal });
    document.addEventListener('pointerdown', (e) => {
      if (trigger.contains(e.target)) return;
      stop();
      if (island === el) hideIsland();
    }, { capture: true, signal: dismiss.signal });
    new MutationObserver((_, mo) => { if (!el.isConnected) { stop(); mo.disconnect(); } }).observe(trigger, { childList: true });
    el.addEventListener('mouseenter', () => clearTimeout(islandTimer));
    el.addEventListener('mouseleave', () => { if (island === el && el.classList.contains('is-typed')) scheduleCollapse(1800); });
    void el.offsetWidth;
    setTimeout(() => el.classList.add('is-open'), 30);
    const chars = [...message];
    let i = 0;
    const type = () => {
      if (island !== el) return;
      if (reduced()) i = chars.length;
      typed.textContent = chars.slice(0, ++i).join('');
      if (i < chars.length) setTimeout(type, 34);
      else { el.classList.add('is-typed'); scheduleCollapse(ISLAND_HOLD); }
    };
    setTimeout(type, reduced() ? 0 : 720);
  }
  window.addEventListener('resize', fitIsland);

  // Replays the "online" announcement (theme editor / QA): aaAndixIntro()
  window.aaAndixIntro = () => {
    try { sessionStorage.removeItem(INTRO_KEY); } catch (e) { /* ignore */ }
    hideIsland(true);
    showIsland();
  };

  let reopened = false;
  try { reopened = sessionStorage.getItem(OPEN_KEY) === '1' && !mqMobile.matches; } catch (e) { /* ignore */ }
  if (reopened) open(false);
  else setTimeout(showIsland, ctxBase.product ? 4500 : 2600);
})();
